import React, {useEffect, useState} from "react";
import {RouteHelper} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import {TagService} from "../../serverService/tagService/TagService";
import TagDetail from "./TagDetail";
import {
    convertUniversalDateTimeToPersianDateTime,
    DialogSize, RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    showErrorMessage,
    RaikoTableTitleContainer,
    RaikoCustomTable
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import StepperWizard from "../../component/stepperWizard/StepperWizard";
import DigikalaGoldChart from "../../component/digikala/digikalaGoldChart/DigikalaGoldChart";
import GoldBuySell from "../../component/digikala/goldBuySell/GoldBuySell";

export default function TagsList() {

    const service = new TagService()

    let page = 0
    const size = 15

    const [tagsData, setTagsData] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [tableListShimmerState, setTableListShimmerState] = useState(false);

    function handlePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    useEffect(() => {
        getDataFromServer()
    }, []);

    function prepareTagsTableRow(number, id, name, createdBy, createdAt) {
        return {
            number,
            id,
            name,
            createdBy,
            createdAt: createdAt ? convertUniversalDateTimeToPersianDateTime(createdAt) : "-"
        }
    }

    function getDataFromServer() {
        setTableListShimmerState(true)
        service.getTagList(
            page,
            size)
            .then(response => {

                setTotalItems(response.numberOfItems)
                setTagsData([])
                response.data.map((item, index) => {
                    setTagsData(prev => [
                        ...prev,
                        prepareTagsTableRow(
                            (page * size) + index + 1,
                            item.id,
                            item.name,
                            item.createdBy,
                            item.createdAt
                        )
                    ])
                })

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableListShimmerState(false)
        })
    }

    function handleSelectRow(rowId) {
        setTagId(rowId)
        handleOpenDialog()
    }

    const [tagDetailDialog, setTagDetailDialog] = useState(false);
    const [tagId, setTagId] = useState(-1);

    function handleOpenDialog() {
        setTagDetailDialog(true)
    }

    function handleCloseDialog() {
        setTagDetailDialog(false)
        setTagId(-1)
    }

    function handleAddNewItemToTable(name) {
        getDataFromServer()
        handleCloseDialog()
    }

    function handleUpdateItemOfTable(id, name) {
        setTableListShimmerState(true)
        const _tags = tagsData
        setTagsData([])
        _tags.map((item, index) => {
            setTagsData(prev => [
                ...prev, {
                    ...item,
                    name: item.id === id ? name : item.name
                }
            ])
        })
        setTableListShimmerState(false)
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={tagDetailDialog}
                pageTitle={"تگ"}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <TagDetail
                    tagId={tagId}
                    handleAddNewItem={handleAddNewItemToTable}
                    handleUpdateItem={handleUpdateItemOfTable}
                />
            </RaikoDefaultDialogPage>
            <RaikoGridOneColumn>
                <RaikoBaseContainer>
                    <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MagazineList.name,
                                RouteHelper.MagazineList.globalUrl,
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.TagList.name,
                                "",
                            ),
                        ]}/>

                        <RaikoBaseCardContainer>
                            <RaikoGridOneColumn>
                                <RaikoTableTitleContainer
                                    title={"آخرین تگ ها"}
                                    hasCreateNewItem
                                    handleCreateNewItem={handleOpenDialog}
                                    amount={totalItems}
                                />
                                <RaikoCustomTable
                                    isLoading={tableListShimmerState}
                                    data={tagsData}
                                    header={tableHeader}
                                    handlePaginationChange={handlePagination}
                                    pageCount={pageCount}
                                    rowClicked={handleSelectRow}
                                />
                            </RaikoGridOneColumn>
                        </RaikoBaseCardContainer>
                    </RaikoGridOneColumn>
                </RaikoBaseContainer>

                {/*<StepperWizard/>*/}
                {/*<DigikalaGoldChart/>*/}
                {/*<GoldBuySell/>*/}
            </RaikoGridOneColumn>

        </>
    )
}


const tableHeader = [
    {
        id: "number",
        label: "#"
    }, {
        id: "name",
        label: "نام"
    }, {
        id: "createdBy",
        label: "سازنده"
    }, {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
]
